import React from 'react';
import Curriculum from '../components/Resume/Resume';

function CV() {

    return (
        <>
            <Curriculum />
        </>
    );
}

export default CV;